module.exports = {
    locale_name: 'Italiano',
    locale_shorthand: ['it', 'italiano'],
    // Translations:
    justifyCenter: 'Centrato',
    justifyLeft: 'Allinea a Sinistra',
    justifyRight: 'Allinea a Destra',
    bold: 'Grassetto',
    code: 'Codice',
    headings: 'Intestazioni (h1-h6)',
    link: 'Collegamento',
    image: 'Inserisci Immagine',
    italic: 'Corsivo',
    orderedList: 'Elenco Ordinato (1, 2, 3, ...)',
    unorderedList: 'Elenco',
    removeFormat: 'Rimuovi formattazione.\nPulisci il test da intestazione, grassetto, corsivo, sottolineato, ecc.',
    separator: null,
    table: 'Inserisci Tabella',
    underline: 'Sottolineato'
}
